import React from 'react';
import { Building2, CalendarSync, FileCheck2, Send } from 'lucide-react';

const STEPS = [
  [Building2, '01', 'Configura la struttura', 'Inserisci l’immobile, le informazioni operative e i collegamenti che utilizzi.'],
  [CalendarSync, '02', 'Riunisci le prenotazioni', 'Visualizza arrivi, partenze e disponibilità in un calendario centralizzato.'],
  [FileCheck2, '03', 'Raccogli e verifica', 'Gli ospiti compilano i dati; tu controlli prima degli invii e degli adempimenti.'],
  [Send, '04', 'Automatizza il seguito', 'Programma comunicazioni e prepara report ordinati per i proprietari.'],
];

export const HomeSmartWorkflow = () => (
  <section id="come-funziona" className="scroll-mt-24 bg-white py-20 sm:py-28" data-testid="workflow-section">
    <div className="mx-auto max-w-6xl px-5 lg:px-8">
      <div className="grid gap-12 lg:grid-cols-[0.75fr_1.25fr] lg:items-start">
        <div className="lg:sticky lg:top-28">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#a17e12]">Un flusso, dall’immobile al report</p>
          <h2 className="mt-4 text-3xl font-extrabold leading-tight text-[#08234c] sm:text-4xl" style={{ fontFamily: 'Georgia, serif' }} data-testid="workflow-title">Sai sempre cosa è fatto e cosa manca.</h2>
          <p className="mt-5 text-base leading-7 text-[#44597e]" data-testid="workflow-description">Home Smart guida le attività quotidiane senza toglierti il controllo nei passaggi che richiedono verifica.</p>
        </div>
        <ol className="border-l border-[#c7d5e8]" data-testid="workflow-steps">
          {STEPS.map(([Icon, number, title, text], index) => <li key={number} className="relative pb-12 pl-8 last:pb-0 sm:pl-12" data-testid={`workflow-step-${index + 1}`}>
            <span className="absolute -left-5 top-0 grid h-10 w-10 place-items-center rounded-full border-4 border-white bg-[#1947C7] text-xs font-extrabold text-white">{number}</span>
            <div className="flex items-start gap-4"><Icon className="mt-1 h-7 w-7 shrink-0 text-[#c09a20]" /><div><h3 className="text-lg font-extrabold text-[#08234c]">{title}</h3><p className="mt-2 text-sm leading-6 text-[#44597e]">{text}</p></div></div>
          </li>)}
        </ol>
      </div>
    </div>
  </section>
);